import { render, staticRenderFns } from "./AdditionalInfoCard.vue?vue&type=template&id=4c8b33c9&scoped=true&"
import script from "./AdditionalInfoCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoCard.vue?vue&type=style&index=0&id=4c8b33c9&prod&lang=scss&scoped=true&"
import style1 from "./AdditionalInfoCard.vue?vue&type=style&index=1&id=4c8b33c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b33c9",
  null
  
)

export default component.exports